import { change } from 'redux-form';

export const getIgaCountries = igaSubClassificationCombos => (igaSubClassificationCombos !== null ? Object.keys(igaSubClassificationCombos) : []);

export const getClassificationKeyValuesForCountry = (country, igaSubclassificationCombos) => {
  if (igaSubclassificationCombos === null) {
    return [];
  }

  const keys = Object.keys(igaSubclassificationCombos).filter(key => key === country);

  if (keys.length >= 1) {
    return igaSubclassificationCombos[keys[0]];
  }

  return [];
};

export const getClassificationsForCountry = (country, igaSubclassificationCombos) => Object.values(getClassificationKeyValuesForCountry(country, igaSubclassificationCombos));

export const updateClassificationOnCountryChange = (dispatch, formName, formPart, igaCountry, igaSubClassificationsCombos, currentIgaSubClassification) => {
  if (igaCountry === '') {
    dispatch(change(formName, formPart, ''));
  } else {
    const classificationsForCountry = getClassificationsForCountry(igaCountry, igaSubClassificationsCombos);

    if (classificationsForCountry.length === 0) {
      dispatch(change(formName, formPart, ''));
    } else if (classificationsForCountry.filter(x => x === currentIgaSubClassification).length === 0) {
      dispatch(change(formName, formPart, ''));
    }
  }
};

export const disabledClassificationTooltip = 'Provide IGA Country to select status';
